import React from 'react';
import { Checkbox, MenuItem } from '@mui/material';
import keyBy from 'lodash/keyBy';
import each from 'lodash/each';
import compact from 'lodash/compact';
import map from 'lodash/map';
import join from 'lodash/join';
import isArray from 'lodash/isArray';
import find from 'lodash/find';
import { Fields } from '@pv/common/components';
import { SpaceChip } from './SpaceChip';

export const spaceValsFromVenue = ({ venue }) => {
  const spaceById = keyBy(venue?.spaces, (s) => s.id);
  let spaces = [];
  const addSpaces = ({ node, depth = 0 }) => {
    spaces = [...spaces, { id: node.id.toString(), depth }];
    each(node.children, (n) => addSpaces({ node: n, depth: depth + 1 }));
  };
  each(venue?.spaceGraph, (node) => {
    addSpaces({ node });
  });

  return compact(
    map(spaces, (space) => {
      const s = spaceById[space.id];
      if (s) {
        let name = s?.name;
        if (s?.seated > 0 || s?.standing > 0) {
          name = `${name} (${join(
            compact([
              s?.seated?.toLocaleString(),
              s?.standing?.toLocaleString(),
            ]),
            ' - '
          )})`;
        }
        return [
          space.id.toString(),
          name,
          false,
          { paddingLeft: `${space.depth * 20}px` },
          spaceById[space.id]?.ignoreConflicts,
        ];
      }
    })
  );
};

export const SpaceSelector = ({
  spaceAvailability = null,
  venue,
  value,
  onChange,
  ...props
}) => {
  const vals = spaceValsFromVenue({ venue });

  const makeOption = (option) => {
    const v = isArray(option) ? option[0] : option;
    const disabled = isArray(option) ? option[2] : false;
    const style = isArray(option) ? { ...option[3] } : {};
    const space = {
      id: v,
      name: option[1],
      ignoreConflicts: option[4],
    };

    return (
      <MenuItem
        key={v}
        value={v}
        disabled={disabled}
        dense
        style={{
          ...style,
          paddingTop: 0,
          paddingBottom: 0,
          backgroundColor: 'transparent',
        }}
        data-cy="dropdown-item"
        role="option"
      >
        <Checkbox
          color="primary"
          checked={!!(value && value.indexOf(v) > -1)}
        />
        <SpaceChip space={space} spaceAvailability={spaceAvailability} />
      </MenuItem>
    );
  };

  const renderValue = (selected) => {
    const selectedSpaces = map(selected, (selectedItem) =>
      find(vals, (s) => s[0]?.toString() === selectedItem?.toString())
    ).filter((s) => !!s);

    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
        {selectedSpaces.map((selectedSpace) => {
          const space = {
            id: selectedSpace[0],
            name: selectedSpace[1],
            ignoreConflicts: selectedSpace[4],
          };

          return (
            <SpaceChip
              key={space.id}
              space={space}
              spaceAvailability={spaceAvailability}
            />
          );
        })}
      </div>
    );
  };

  return (
    <Fields.PvMultiSelect
      renderValue={spaceAvailability && renderValue}
      makeOption={spaceAvailability && makeOption}
      vals={vals}
      onChange={onChange}
      value={value}
      name="space"
      label="Space"
      data-cy="create-event-space-multiselect"
      {...props}
    />
  );
};

export default SpaceSelector;
